import { BooleanInput } from '@angular/cdk/coercion';
import { Platform } from '@angular/cdk/platform';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  contentChildren,
  input,
  InputSignal,
  InputSignalWithTransform,
  Signal,
  ViewEncapsulation
} from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

import { InputPrefixDirective } from './input-prefix';
import { InputSuffixDirective } from './input-suffix';

@Component({
  selector: 'tiime-input-container',
  host: {
    /* eslint-disable @typescript-eslint/naming-convention */
    '[class.firefox]': 'platform.FIREFOX',
    '[class.label-margin]': 'label() && !fixedLabel()',
    '[class.small]': 'small()',
    '[class.large]': 'large()',
    '[class.fixed-label]': 'fixedLabel()',
    '[class.input-container-disabled]': 'control()?.disabled || readonly()',
    class: 'tiime-input-container'
    /* eslint-enable @typescript-eslint/naming-convention */
  },
  templateUrl: './input-container.component.html',
  styleUrls: ['input-container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class InputContainerComponent {
  readonly contentId: InputSignal<string> = input<string>();
  readonly label: InputSignal<string> = input<string>();
  readonly errorMessage: InputSignal<string> = input<string>();
  readonly required: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly fixedLabel: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly small: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly large: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly readonly: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });

  protected readonly control: Signal<NgControl> = contentChild(NgControl);
  protected readonly suffix: Signal<ReadonlyArray<InputSuffixDirective>> = contentChildren(InputSuffixDirective);
  protected readonly prefix: Signal<ReadonlyArray<InputSuffixDirective>> = contentChildren(InputPrefixDirective);

  protected readonly displaySuffix: Signal<boolean> = computed(() => !!this.suffix()?.length);
  protected readonly displayPrefix: Signal<boolean> = computed(() => !!this.prefix()?.length);
  protected readonly placeholder: Signal<string> = computed(() => {
    const label = this.label();
    const required = this.required();
    const control = this.control();
    return `${label}${required || control?.control?.hasValidator(Validators.required) ? '*' : ''}`;
  });

  constructor(public platform: Platform) {}
}
